import { gql } from '@apollo/client';

export const ProductPriceFragment = gql`
  fragment ProductPriceFragment on Variant {
    price {
      currency
      percentOff
      basePrice
      discountPrice
    }
  }
`;

export default {};
